<template>
  <div
    class="application-base"
    :class="{'application-base--preview': view === 'preview'}"
  >

    <SimpleModal
      v-if="modals.prefillApplication.show"
      :handleSubmit="() => loadApplicationDataFromAPI(prefillForm.ssn, prefillForm.applicationGUID, applicationType)"
      :handleCancel="() => $emit('showModal', 'prefillApplication', false)"
      :customPrimaryButtonClass="`
        ${applicationType === 'aso' ? ' btn--green ' : ''}
        ${applicationType === 'rent' ? ' btn--green ' : ''}
        ${applicationType === 'owner-occupancy' ? ' btn--green ' : ''}
      `"
      :isLoading="modals.prefillApplication.loading"
      :hasError="modals.prefillApplication.error"
      :errorMessage="modals.prefillApplication.errorMessage ? translate(modals.prefillApplication.errorMessage) : ''"
      :primaryButtonText="`
        ${applicationType === 'aso' ? translate('aso: Hae hakemustiedot') : ''}
        ${applicationType === 'rent' ? translate('rent: Hae hakemustiedot') : ''} +
        ${applicationType === 'owner-occupancy' ? translate('owner-occupancy: Hae hakemustiedot') : ''}
      `"
      :cancelButtonText="`
        ${applicationType === 'aso' ? translate('aso: Peruuta') : ''}
        ${applicationType === 'rent' ? translate('rent: Peruuta') : ''} +
        ${applicationType === 'owner-occupancy' ? translate('owner-occupancy: Peruuta') : ''}
      `"
      :loadingText="(
        '' +
        applicationType === 'aso' ? translate('aso: Ladataan hakemustietoja') : '' +
        applicationType === 'rent' ? translate('rent: Ladataan hakemustietoja') : '' +
        applicationType === 'owner-occupancy' ? translate('owner-occupancy: Ladataan hakemustietoja') : ''
      )"
      :submitDisabled="prefillFormHasErrors"
    >
      <h2>
        {{ applicationType === 'aso' ? translate("aso: Jatka hakemusta") : '' }}
        {{ applicationType === 'rent' ? translate("rent: Jatka hakemusta") : '' }}
        {{ applicationType === 'owner-occupancy' ? translate("owner-occupancy: Jatka hakemusta") : '' }}
      </h2>

      <template v-if="disableFormFromWordPress && !userLoggedIn">
        <div v-html="formDisabledContent" />
        <br><br>
      </template>
      <div v-else>
      <p>
        {{ applicationType === 'aso' ? translate("aso: Voit jatkaa aiemmin täyttämääsi hakemusta vahvistamalla henkilötunnuksesi. Henkilötunnuksen tulee täsmätä päähakijan henkilötunnuksen kanssa.") : '' }}
        {{ applicationType === 'rent' ? translate("rent: Voit jatkaa aiemmin täyttämääsi hakemusta vahvistamalla henkilötunnuksesi. Henkilötunnuksen tulee täsmätä päähakijan henkilötunnuksen kanssa.") : '' }}
        {{ applicationType === 'owner-occupancy' ? translate("owner-occupancy: Voit jatkaa aiemmin täyttämääsi hakemusta vahvistamalla henkilötunnuksesi. Henkilötunnuksen tulee täsmätä päähakijan henkilötunnuksen kanssa.") : '' }}
      </p>
      <label for="ssn" :style="`${prefillForm.touched && prefillFormHasErrors ? 'color: red;' : ''}`">
        {{ applicationType === 'aso' ? translate("aso: Päähakijan henkilötunnus") : '' }}
        {{ applicationType === 'rent' ? translate("rent: Päähakijan henkilötunnus") : '' }}
        {{ applicationType === 'owner-occupancy' ? translate("owner-occupancy: Varaajan henkilötunnus") : '' }}
      </label>
      <input
        :type="prefillForm.showSSN ? 'text' : 'password'"
        v-model="prefillForm.ssn"
        :placeholder="(
          '' +
          applicationType === 'aso' ? translate('aso: Syötä päähakijan henkilötunnus') : '' +
          applicationType === 'rent' ? translate('rent: Syötä päähakijan henkilötunnus') : '' +
          applicationType === 'owner-occupancy' ? translate('owner-occupancy: Syötä Varaajan henkilötunnus') : ''
        )"
        :style="`${prefillForm.touched && prefillFormHasErrors ? 'border-bottom: 1px solid red; background-color: #ffe8e9;' : ''}`"
        @blur="() => prefillForm.touched = true"
        autofocus
      >
      <div class="avain_application_errorLabel" v-if="prefillForm.touched && prefillFormHasErrors">
          {{ applicationType === 'aso' ? translate("aso: Tarkista henkilötunnus") : '' }}
          {{ applicationType === 'rent' ? translate("rent: Tarkista henkilötunnus") : '' }}
          {{ applicationType === 'owner-occupancy' ? translate("owner-occupancy: Tarkista henkilötunnus") : '' }}
      </div>
      <div style="display: block; margin-bottom: 12px;">
        <InputCheckbox v-model="prefillForm.showSSN">
          {{ applicationType === 'aso' ? translate("aso: Näytä henkilötunnus") : '' }}
          {{ applicationType === 'rent' ? translate("rent: Näytä henkilötunnus") : '' }}
          {{ applicationType === 'owner-occupancy' ? translate("owner-occupancy: Näytä henkilötunnus") : '' }}
        </InputCheckbox>
      </div>
      <label for="application_id">
        {{ applicationType === 'aso' ? translate("aso: Hakemustunniste (täytetty automaattisesti)") : '' }}
        {{ applicationType === 'rent' ? translate("rent: Hakemustunniste (täytetty automaattisesti)") : '' }}
        {{ applicationType === 'owner-occupancy' ? translate("owner-occupancy: Hakemustunniste (täytetty automaattisesti)") : '' }}
      </label>
      <input type="text" v-model="prefillForm.applicationGUID" disabled>
      </div>
    </SimpleModal>

    <ApplicationModal
      v-if="modals.loadPreset.show"
      :title="modals.loadPreset.title"
    >
      {{modals.loadPreset.content}}

      <template v-slot:actions="slot">
        <button
          class="btn btn--large"
          :class="[`btn--${color}`, slot.classAction]"
          @click="$emit('showModal', 'loadPreset', false)"
        >
          {{modals.loadPreset.textClose}}
        </button>
      </template>
    </ApplicationModal>

    <ApplicationModal
      v-if="modals.confirmReset.show"
      :title="textReset"
    >
      {{textResetConfirm}}

      <template v-slot:actions="slot">
        <button
          class="btn btn--large btn--outline"
          :class="[`btn--${color}`, slot.classAction]"
          @click="$emit('showModal', 'confirmReset', false)"
        >
          {{translate('Peruuta')}}
        </button>
        <button
          class="btn btn--large"
          :class="[`btn--${color}`, slot.classAction]"
          @click="move('reset')"
        >
          {{textReset}}
        </button>
      </template>
    </ApplicationModal>

    <ApplicationModal
      v-if="modals.confirmDeactivation.show"
      :title="textDeactivateConfirmTitle"
    >
      {{textDeactivateConfirmText}}

      <template v-slot:actions="slot">
        <button
          class="btn btn--large btn--outline"
          :class="[`btn--green`, slot.classAction]"
          @click="$emit('showModal', 'confirmDeactivation', false)"
        >
          {{translate('Peruuta')}}
        </button>
        <button
          class="btn btn--large"
          :class="[`btn--green`, slot.classAction]"
          @click="[$emit('showModal', 'confirmDeactivation', false), move('deactivateApplication')]"
        >
          {{textDeactivateButton}}
        </button>
      </template>
    </ApplicationModal>

    <OrderNumberModal

    />

    <div
      v-if="view === 'form' || view === 'success'"
      class="backdrop-container backdrop-container--contain"
      :class="{'application-base--success': view === 'success'}"
    >

      <div class="container">
				<h1
          class=""
          v-html="hero.title"
        />
      </div>

      <!-- Application base top -->
      <div class="container container--narrow application-section application-base__top">
          <ApplicationSection
            v-if="view === 'form' && applicationType != 'owner-occupancy'"
            :title="translate('Hakemuksesta')"
            class="print-hide"
          >
            <div class="application-base__instructions wysiwyg">
              <div v-html="textBefore"/>
            </div>
          </ApplicationSection>
          <ApplicationSection
              v-if="view === 'form' && applicationType == 'owner-occupancy'"
              :title="translate('Varausseloste')"
              class="print-hide"
            >
              <div class="application-base__instructions wysiwyg">
                <div v-html="textBefore"/>
              </div>
            </ApplicationSection>

          <div
            v-if="$slots.top && applicationType != 'owner-occupancy'"
            class="application-base__top-slot"
          >
            <slot name="top"/>
          </div>
      </div>

      <ApplicationDivider v-if="view === 'form' && warningApartmentsBefore" />

      <!-- ApplicationSection & ApplicationApartments -->
      <div class="container container--narrow application-section">

        <ApplicationSection v-if="view === 'form' && warningApartmentsBefore">
          <div
            class="wysiwyg warning-text print-hide"
            :class="`border--${color}`"
            v-html="warningApartmentsBefore"
          />
        </ApplicationSection>

        <!-- ApplicationApartments -->
        <div class="application-base__apartments">
          <slot name="apartments"/>
        </div>

      </div>

      <!-- ApplicationApplicants -->
      <slot/>


      <div class="container container--narrow application-section">
        <ApplicationSection v-if="view === 'form' && applicationType != 'owner-occupancy'">
          <div
            v-if="textAfter"
            class="wysiwyg warning-text print-hide"
            :class="`border--${color}`"
            v-html="textAfter"
          />
        </ApplicationSection>
      </div>
      <ApplicationDivider v-if="view === 'form' && textAfter && applicationType != 'owner-occupancy'" wrapperClasses="container" />

      <div class="container">
        <div class="application-base__bottom-grid">
          <div class="application-base__bottom-grid-item--left application-base__bottom-grid-row print-hide">

            <!-- Left column -->
            <div class="application-base__center-button">

              <!-- Print -->
              <button
                @click="print"
                class="btn btn--white btn--outline btn--large"
              >
                <PrintIcon
                  class="application-base__print-icon"
                  :class="`icon--${color}`"/>
                  {{
                    applicationType != 'owner-occupancy' ?
                    translate('Tulosta hakemus') :
                    translate('Tulosta varaus')
                  }}
              </button>
            </div>

          </div>

          <!-- Right column -->
          <div class="application-base__bottom-grid-item--right application-base__bottom-grid-column">

              <div
                v-if="validations.$error"
                class="application-base__bottom-label application-base__error"
              >
                {{translate('Täytä puuttuvat kentät.')}}
              </div>

              <div
                v-if="!loading && !hasApartments"
                class="application-base__bottom-label application-base__error print-hide"
              >
                {{translate('Hakemuksella ei ole asuntoja.')}}
              </div>

              <div class="application-base__bottom-label">
                <InputCheckbox v-model="agree"
                  wrapperClasses="input-wrapper input-wrapper--flex"
                >
                  {{labelAgree.start}}

                  <a v-if="labelAgree.insertLink"
                    :href="urlTerms"
                    target="_blank"
                    class="application-base__terms-link"
                  >
                    {{translate('hyväksyn käyttöehdot')}}
                  </a>
                  {{labelAgree.end}}
                </InputCheckbox>
              </div>

              <div
                v-if="submitError"
                class="application-base__error application-base__bottom-label"
              >
                {{translate('Hakemuksen lähetys epäonnistui.')}}
              </div>

              <div
                v-if="deactivateError"
                class="application-base__error application-base__bottom-label"
              >
                {{translate('Hakemuksen poistaminen epäonnistui.')}}
              </div>

            <div class="row g-4">

              <!-- Left buttons -->
              <div class="col-sm-6">
                <button
                  v-if="view === 'form'"
                  @click="$emit('showModal', 'confirmReset', true)"
                  class="btn btn--large btn--outline w-100"
                  :class="`btn--${color}`"
                >
                  {{textReset}}
                </button>

                <!-- Deactivate -->
                <button
                  v-if="view === 'form' && this.isExistingApplication"
                  @click="$emit('showModal', 'confirmDeactivation', true)"
                  class="application-base__btn-wide btn btn--large print-hide btn--blue-deep"
                  style="margin-top: 1rem;"
                  :id="`application-base-button-${applicationType}-deactivate`"
                  :data-id="`application-base-button-${applicationType}-deactivate`"
                >
                  <LoadSpinner
                    v-if="deactivating"
                    :margin="false"
                  />
                  <template v-else>
                    {{textDeactivate}}
                  </template>
                </button>

              </div>

              <!-- Right buttons -->
              <div class="col-sm-6">
                <button
                  @click="move('submit')"
                  class="application-base__btn-wide btn btn--large print-hide w-100"
                  :class="`btn--${color}`"
                  :disabled="submitDisabled"
                  :id="`application-base-button-${applicationType}-2003`"
                  :data-id="`application-base-button-${applicationType}-2003`"
                >
                  <LoadSpinner
                    v-if="submitting"
                    :margin="false"
                  />
                  <template v-else>
                    {{textSubmit}}
                  </template>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="application-base__controls-fixed print-hide"
      v-if="view === 'form'"
    >
      <div
        v-if="textFixedControls"
        class="application-base__controls-fixed-text"
      >
        {{textFixedControls}}
      </div>
      <div class="application-base__controls-fixed-buttons">
        <button
          @click="$emit('showModal', 'confirmReset', true)"
          class="btn btn--outline"
          :class="`btn--${color}`"
        >
          {{textReset}}
        </button>
        <button
          @click="move('submit')"
          class="btn"
          :class="`application-base__controls-fixed-submit btn--${color}`"
          :disabled="submitDisabled"
          :id="`application-base-button-${applicationType}-2003b`"
          :data-id="`application-base-button-${applicationType}-2003`"
        >
          <LoadSpinner
            v-if="submitting"
            :margin="false"
          />
          <template v-else>
            {{textSubmit}}
          </template>
        </button>
      </div>
    </div>

    <div
      v-if="view === 'success' || view === 'deactivation-success'"
      class="backdrop-container print-hide"
    >
      <div class="application-success container">

        <div class="application-success__item">
          <div class="application-success__row">
            <div
              class="application-success__column application-success__content wysiwyg"
              v-html="success.content"
            />
          </div>
        </div>

        <div
          v-if="view !== 'deactivation-success'"
          class="application-base__center-button application-success__print"
        >
          <button
            @click="print"
            class="btn btn--white btn--outline btn--large"
          >
          <PrintIcon
            class="application-base__print-icon"
            :class="`icon--${color}`"/>
            {{translate('Tulosta hakemus')}}
          </button>
        </div>

        <div
          v-if="success.applyOther.show"
          class="application-success__item"
        >
          <div class="application-success__title">
            {{success.applyOther.title}}
          </div>
          <div class="application-success__row">
            <div class="application-success__column application-success__column--large">
              <div
                class="application-success__content wysiwyg"
                v-html="success.applyOther.content"
              />
            </div>
            <div class="application-success__column application-success__column--small">
              <button
                @click="move('applyOther')"
                :class="`btn--${success.applyOther.color}`"
                class="btn btn--large"
              >
                {{success.applyOther.ctaText}}
                <ArrowIcon class="btn__icon btn__icon--right" />
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {FinnishSSN} from 'finnish-ssn';
  import globals from '../../lib/globals';
  import utils from '../mixins/utils';
  import ApplicationSection from './ApplicationSection';
  import ApplicationDivider from './ApplicationDivider';
  import ApplicationModal from './ApplicationModal';
  import OrderNumberModal from './OrderNumberModal';
  import InputWrap from './InputWrap';
  import InputTextarea from './InputTextarea';
  import InputCheckbox from './InputCheckbox';
  import LoadSpinner from './LoadSpinner';
  import SimpleModal from "./SimpleModal";
  import ArrowIcon from '../icons/ArrowIcon.vue';
  import PrintIcon from '../icons/PrintIcon.vue';

  export default {
    mixins: [
      utils.translate,
    ],
    components: {
    ApplicationSection,
    ApplicationDivider,
    ApplicationModal,
    OrderNumberModal,
    InputWrap,
    InputTextarea,
    InputCheckbox,
    LoadSpinner,
    SimpleModal,
    ArrowIcon,
    PrintIcon
},
    props: {
      applicationType: {
        type: String,
        default: '',
      },
      view: {
        type: String,
        required: true,
      },
      hero: {
        type: Object,
        required: true,
      },
      textBefore: {
        type: String,
        default: '',
      },
      textAfter: {
        type: String,
        default: '',
      },
      warningApartmentsBefore: {
        type: String,
        default: '',
      },
      success: {
        type: Object,
        required: true,
      },
      validations: {
        type: Object,
        required: true,
      },
      submitting: {
        type: Boolean,
        required: true,
      },
      deactivating: {
        type: Boolean,
        required: true,
      },
      loading: {
        type: Boolean,
        required: true,
      },
      submitError: {
        type: Boolean,
        required: true,
      },
      deactivateError: {
        type: Boolean,
        required: true,
      },
      hasApartments: {
        type: Boolean,
        required: true,
      },
      isExistingApplication: {
        type: Boolean,
        required: true,
      },
      existingApplicantIndexes: {
        type: Object,
        default() { return {} },
        required: true,
      },
      color: {
        type: String,
        default: 'default',
      },
      theOtherColor: {
        type: String,
        default: 'default',
      },
      modals: {
        type: Object,
        required: true,
      },
      loadApplicationDataFromAPI: {
        type: Function
      },
      disableFormFromWordPress: {
        type: Boolean,
        required: false,
        default: false,
      }
    },
    data() {
      return {
        agree: false,
        urlTerms: globals.urlTermsOfUse,
        prefillForm: {
          applicationGUID: "",
          ssn: "",
          showSSN: false,
          touched: false,
          error: ""
        },
        userLoggedIn: globals.userLoggedIn,
      };
    },
    mounted() {
      const queryParams = utils.generalHelpers.methods.getJSONFromURL()

      if (queryParams.application) {
        this.prefillForm.applicationGUID = queryParams.application
      } else if (queryParams.applicationlocal) {
        this.prefillForm.applicationGUID = queryParams.applicationlocal
      }
    },
    computed: {
      labelAgree() {
        const base = this.translate('Olen tarkistanut tietojen oikeellisuuden ja %s.');
        const parts = base.split('%s');
        return {
          insertLink: parts.length > 1,
          start: parts.shift(),
          end: parts.join(''),
        };
      },
      textFixedControls() {
        if (this.applicationType == 'owner-occupancy') {
          return this.isExistingApplication
          ? this.translate('Omistusasuntohakemus: Kelluva muistutus, varauksen päivitys')
          : this.translate('Omistusasuntohakemus: Kelluva muistutus, varauksen lähetys');
        } else {
          return this.isExistingApplication
          ? this.translate('Asuntohakemus: Kelluva muistutus, hakemuksen päivitys')
          : this.translate('Asuntohakemus: Kelluva muistutus, hakemuksen lähetys');
        }

      },
      textReset() {
        if(this.applicationType == 'owner-occupancy') {
          return this.isExistingApplication
            ? this.translate('Omistusasuntovaraus: Kirjaudu ulos')
            : this.translate('Omistusasuntovaraus: Tyhjennä varaus');
      } else {
          return this.isExistingApplication
            ? this.translate('Asuntohakemus: Kirjaudu ulos')
            : this.translate('Asuntohakemus: Tyhjennä hakemus');
          }
      },
      textResetConfirm() {
        if (this.applicationType == 'owner-occupancy') {
          return this.isExistingApplication
            ? this.translate('Omistusasuntovaraus: Kirjaudu ulos, vahvistus')
            : this.translate('Omistusasuntovaraus: Tyhjennä varaus, vahvistus');
        } else {
          return this.isExistingApplication
            ? this.translate('Asuntohakemus: Kirjaudu ulos, vahvistus')
            : this.translate('Asuntohakemus: Tyhjennä hakemus, vahvistus');
        }

      },
      textSubmit() {
        if (this.applicationType == 'owner-occupancy') {
          return this.translate(this.isExistingApplication ? 'Päivitä varaus' : 'Jätä varaus');
        } else {
          return this.translate(this.isExistingApplication ? 'Päivitä hakemus' : 'Jätä hakemus');
        }
      },
      textDeactivate() {
        return this.translate('Hakemukseni ei ole enää ajankohtainen');
      },
      textDeactivateConfirmTitle() {
        return this.translate('Haluatko varmasti poistaa hakemuksesi?');
      },
      textDeactivateConfirmText() {
        return this.translate('Hakemuksesi poistetaan etkä enää saa asuntotarjouksia.');
      },
      textDeactivateButton() {
        return this.translate('Poista hakemus');
      },
      submitDisabled() {
        if(this.userLoggedIn) {
          return !this.agree || this.submitting || this.loading || !this.hasApartments;
        } else {
          return !this.agree || this.submitting || this.loading || !this.hasApartments || this.disableFormFromWordPress;
        }
      },
      prefillFormHasErrors() {
        return !FinnishSSN.validate(this.prefillForm.ssn.toUpperCase())
      },
      formDisabledContent() {
        return globals.formDisabledFromWordPressReason;
      },
    },
    methods: {
      validateSSN: FinnishSSN.validate,
      validatePrefillFormSSN() {
        if (this.prefillForm.touched && !FinnishSSN.validate(this.prefillForm.ssn.toUpperCase())) {
          this.prefillForm.error = this.translate(`${this.applicationType}: Tarkista henkilötunnus`)
        }
      },
      move(to) {
        this.$emit('move', to)
      },
      print() {
        window.print();
      },
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .application-base {
    margin-top: $theme-spacing * 2;
    margin-bottom: r(128);
    &--success {
      display: none;
    }
    @media print {
      margin-bottom: 0;
      &--success {
        display: block;
      }
    }

    h1 {
      margin-top: r(40);
      margin-bottom: r(40);

      @include media-breakpoint-up(lg) {
        margin-top: r(80);
        margin-bottom: r(80);
      }
    }

    .form-check-label {
      margin-left: $theme-spacing * 0.25;
    }
  }


  .application-base__top {
    margin-bottom: r(32);
  }

  .application-base__top-slot {
    margin-top: r(64);

    .application-base--preview & {
      margin-top: 0;
    }
  }

  .application-base__instructions {
    @include font-responsive-body-large;
  }

  .application-base__apartments {
    margin-bottom: r(32);
    margin-top: r(16);
  }

  .application-base__text-after {
    text-align: center;
    margin: r(50) 0;
    flex-direction: column;
  }

  .application-base__center-button .btn{
    padding-left: 0;
  }

  .application-base__error {
    color: $color-red;
  }

  .application-base__btn-wide {
    width: r(300);
    max-width: 100%;
  }

  .application-base__print-icon {
    margin: r(-14) 0;

    svg {
      @include square(r(28));
    }
  }

  .application-base__bottom-grid {

    display: flex;
    flex-flow: column;

    @include media-breakpoint-up(md) {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-flow: row;
    }
  }

  .application-base__bottom-grid-item {
    &--left {
      order: 2;
      margin-top: r(24);

      @include media-breakpoint-up(md) {
        margin: 0;
        order: 1;
      }
    }

    &--right {
      order: 1;

      @include media-breakpoint-up(md) {
        align-items: flex-end;
        margin-left: r(24);
        order: 2;
      }
    }
  }

  .application-base__bottom-grid-column {
    display: flex;
    flex-direction: column;

    @include media-breakpoint-up(md) {
      align-items: flex-start;
    }
  }

  .application-base__bottom-label, .application-base__center-button {
    margin-bottom: r(12);

    @include media-breakpoint-up(md) {
      margin-bottom: r(24);
    }
  }

  .application-base__terms-link {
    text-decoration: underline;
    color: $color-green-2025;
    margin-left: $theme-spacing * 0.5;
  }

  .application-base__controls-fixed {
    @include card;
    position: fixed;
    z-index: 10;
    left: 0;
    right: 0;
    bottom: 0;
    padding: r(8);
    border-radius: 0;
    background-color: $color-white;

    @include media-breakpoint-up(sm) {
      border-top-left-radius: r(4);
      left: auto;
    }
  }

  .application-base__controls-fixed-text {
    @include font-body-10;
    width: 100%;
    margin-bottom: r(8);
    text-align: center;

    @include media-breakpoint-up(md) {
      @include font-body-12;
    }
  }

  .application-base__controls-fixed-buttons {
    display: flex;
    justify-content: space-between;
  }

  .application-base__controls-fixed-submit {
    margin-left: r(24);
  }

  .avain_application_errorLabel {
    background: transparent;
    color: #ff1515;
    font-size: 14px;
    line-height: 15.5px;
    margin-bottom: 8px;
    margin-top: -12px;
  }
</style>
